import { render } from "./integral.vue?vue&type=template&id=56f983d6"
import script from "./integral.vue?vue&type=script&lang=js"
export * from "./integral.vue?vue&type=script&lang=js"
script.render = render

export default script